<form [formGroup]="form" class="mx-auto upload-story-dialog-form font-title">
    <h2 class="font-title font-bold" style="margin-bottom: 3rem">{{ 'storyAssignedDialog.text1' | translate}} {{ username | translate}}</h2>
    <mat-label>{{ 'storyAssignedDialog.text2' | translate}}</mat-label>
    <mat-label>{{ readingLevel | translate}}</mat-label>
    <mat-form-field appearance="outline" class="w-full font-title">
        <mat-label>{{ 'storyAssignedDialog.text5' | translate}}</mat-label>
        <mat-select [formControl]="storyName" class="font-title"  (selectionChange)="setSelectedStorybook($event)">
            <!-- formControlName="storybookId" -->
                <mat-option class="font-title" *ngFor="let storybook of currentStorybooks" [value]="storybook.storybookId">
                    {{storybook.storyName}}
                </mat-option>
            </mat-select>
        <mat-error *ngIf="(storyName.dirty || storyName.touched) && storyName.errors?.required">{{ 'storyAssignedDialog.text3' | translate}}</mat-error>
    </mat-form-field>
    <div class="image-container" *ngIf="storybookSelected">
        <label for="storybook-cover-image">{{ 'editStory.text14' | translate }} </label>
        <img *ngIf="selectedStorybook.coverImagePath" src="{{selectedStorybook.coverImagePath}}" alt="" class="storybook-cover-image" name="storybook-cover-image"/>
        <img *ngIf="!selectedStorybook.coverImagePath" src="../../../../assets/imgs/sample.png" alt="" class="storybook-cover-image" name="storybook-cover-image"/>
    </div>
    <div class="button-group vertical mt-8 upload-dialog-btn-container">
        <button mat-raised-button color="primary" (click)="submitAndClose()" [disabled]="!form.valid" class="btn font-title">{{ 'storyAssignedDialog.text6' | translate}}</button>
        <button mat-button color="primary" [mat-dialog-close] class="font-title">{{ 'storyAssignedDialog.text7' | translate}}</button>
    </div>
</form>
